/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { addthresholdDevicesColumns, thresholdDevicesColumns } from "../../../Shared/Table/Columns";
import { IThresholdCrossingSettingProfile, IThresholdDevice } from "../../../../store/api/admin/types";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { useThresholdDevices } from "./hooks";
import { IFilter } from "../../../Shared/Filter/types";
import AssociationControl from "../../../Shared/Association/AssociationControl";
import { payloadKeyList } from "../../../Shared/Association/AssociationHelper";
import { setResetFilters, setResetAddDeviceFilters } from "../../../../store/filters/profiles/ThresholdCrossingDeviceFilterReducers";
import DeviceDrawer from "../../../Drawers/DeviceDrawer";

interface IThresholdDeviceProps {
  selectedProfile: IThresholdCrossingSettingProfile;
  canManage: boolean;
  onAssociationChanged?: () => void;
}

const ThresholdDevice: React.FC<IThresholdDeviceProps> = ({ selectedProfile, canManage, onAssociationChanged }) => {
  const {
    searchFilters,
    searchAddFilters
  } = useThresholdDevices();

  const removeDeviceFilters: IFilter = {
    searchTooltip: "",
    selectFilters: searchFilters
  };

  const addDeviceFilters: IFilter = {
    searchTooltip: "",
    selectFilters: searchAddFilters
  };

  const entity = { value: selectedProfile.id, text: selectedProfile.name, enabled: selectedProfile.enabled };
  return (
    <>
     <div className="flex-1 min-h-[180px] pt-2 ml-0">
        <AssociationControl
          entity={entity}
          parentEntityName={"profile"}
          childEntityName={"Device"}
          associationPermission={canManage}
          listFilters={removeDeviceFilters}
          listColumns={thresholdDevicesColumns}
          listSorting={"name, asc"}
          listResetFilterHandler={setResetFilters}  // check
          listCheckboxSelection={true}
          listDisableColumnMenu={true}
          listDisableRowSelectionOnClick={true}
          listMutationKey={"removeThresholdDevices"}
          listMutationPayloadKey={payloadKeyList.removeThresholdDevices}
          urlListParameterKey={"getThresholdMapped"}
          loadListDataKey={"getThresholdMapped"}
          listDialogOpener={DIALOGOPENFOR.ADDTHRESHOLDDEVICE}
          addModelHeaderName={"Add device"}
          visibleAdd={canManage}
          addButtonName={"Add Device"}
          showRemoveAction={canManage}
          confirmRemoveDialogOpener={DIALOGOPENFOR.REMOVETHRESHOLDDEVICES}
          removeConfirmationMessage={"Are you sure you want to remove the selected device from profile:"}
          addFilters={addDeviceFilters}
          addColumns={addthresholdDevicesColumns}
          addSorting={"name, asc"}
          addResetFilterHandler={setResetAddDeviceFilters}
          showAddAction={false}
          showAddAll={canManage}
          addCheckboxSelection={true}
          addDisableColumnMenu={true}
          addDisableRowSelectionOnClick={true}
          addMutationKey={"addThresholdDevices"}
          addMutationPayloadKey={payloadKeyList.addThresholdDevices}
          urlAddParameterKey={"getThresholdUnmapped"}
          loadAddDataKey={"getThresholdUnmapped"}
          loadAddAllDataKey={"getThresholdAllUnmapped"}
          addShowInfoMessage={false}
          listHeight={"410px"}
          listDrawerItem={DeviceDrawer}
          onAssociationChanged={onAssociationChanged}
        />
      </div>
    </>
  );
};

export default ThresholdDevice;